var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-box"},[_c('canvas',{ref:"canvas",staticClass:"qr-canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }